module.exports = __webpack_public_path__ + "img/nosotros_home.298ca81b.jpg";